export function getTruncatedFileName(name: string, extension: string, maxLength = 20): string {
  if (!name || !extension) return '-';

  const fullName = `${name}.${extension}`;
  if (fullName.length <= maxLength) return fullName;

  const truncated = name.slice(0, maxLength - extension.length - 3); // -3 for '...'
  return `${truncated}...${fullName.slice(-extension.length)}`;
}
